export const createOrder = (order) => {
  return new Promise(async (resolve) => {
    const response = await fetch("/orders/createOrder", {
      method: "POST",
      body: JSON.stringify(order),
      headers: { "content-type": "application/json" },
    });
    const data = await response.json();
    resolve({ data });
  });
};

export const createOrderWithCard = (order) => {
  return new Promise(async (resolve) => {
    const response = await fetch("/orders/createOrderWithCard", {
      method: "POST",
      body: JSON.stringify(order),
      headers: { "content-type": "application/json" },
    });
    const data = response.json();
    resolve({ data });
  });
};
export const validateOrderWithCard = (paymentResponse) => {
  return new Promise(async (resolve) => {
    const response = await fetch("/orders/validateOrderWithCard", {
      method: "POST",
      body: JSON.stringify(paymentResponse),
      headers: { "content-type": "application/json" },
    });
    const data = response.json();
    console.log(data);
    // resolve({ data });
  });
};

export const fetchOrdersByUser = () => {
  return new Promise(async (resolve) => {
    const response = await fetch("/orders/fetchOrdersByUser");
    const data = await response.json();
    resolve({ data });
  });
};
export const cancelOrder = (id) => {
  return new Promise(async (resolve) => {
    const response = await fetch("/orders/cancelOrder/" + id);
    const data = await response.json();

    resolve({ data });
  });
};
